import { Tabs, Tab } from '@shared/uikit/tabs';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

const TABS: Array<Tab> = [
  { value: 'personal', content: 'Личный результат' },
  { value: 'team', content: 'Командный результат' },
  { value: 'salary', content: 'Заработная плата' },
];

export const ManagersTabs = ({ value, onChange }: Props) => (
  <Tabs tabs={TABS} value={value} onClickTab={tab => onChange(tab.value)} className="mb-5" />
);
